import { DateTime } from 'luxon';

/**
 * Computes an end date from a start date and day count using the same clock time as the start.
 * Round-trips with {@link toComputedPeriodDuration} when `units` is `['days']`.
 */
export function toEndsAtFromDurationDays(
	startsAt: Date | null | undefined,
	durationDays: number | null | undefined,
): Date | null {
	if (!startsAt || durationDays == null || durationDays < 0) {
		return null;
	}

	return DateTime.fromJSDate(startsAt).plus({ days: durationDays }).toJSDate();
}

/**
 * Shifts an end date by the change in duration days. Use when adjusting duration
 * incrementally so each step moves `endsAt` by one day, even when
 * {@link toComputedPeriodDuration} (ceil) differs from `startsAt + durationDays`.
 */
export function toEndsAtFromDurationDaysChange(
	endsAt: Date | null | undefined,
	previousDurationDays: number,
	newDurationDays: number,
): Date | null {
	if (!endsAt) {
		return null;
	}

	const delta = newDurationDays - previousDurationDays;
	return DateTime.fromJSDate(endsAt).plus({ days: delta }).toJSDate();
}
